import {BehaviorSubject, Subject, Subscription} from "rxjs";
import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";

import { CarteiraFilter } from "./carteira.model";
import {CarteiraListaComponent} from "./carteira-lista/carteira-lista.component";
import {CarteiraPesquisaComponent} from "./carteira-pesquisa/carteira-pesquisa.component";
import {CarteiraService} from "./carteira.service";
import { MatDialog } from "@angular/material/dialog";
import { ModalConfirmComponent } from "../shared/components/modal-confirm/modal-confirm.component";
import {PageService} from "../shared/layout/services/page.service";
import { PageableCarteiraFilter } from "./pageable-carteira-filter";
import {PaginationResponse} from "../shared/form/pagination-response";
import {ToastService} from "maps-angular-components";

@Component({
  selector: "app-carteira",
  templateUrl: "./carteira.component.html",
  styleUrls: ["./carteira.component.scss"],
})
export class CarteiraComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  @ViewChild(CarteiraPesquisaComponent, { static: false })
  pesquisaCmp: CarteiraPesquisaComponent;
  @ViewChild(CarteiraListaComponent, { static: false })
  listaCmp: CarteiraListaComponent;
  ativaEnquadramento = true;
  processamentoAuto = true;
  page$: Subject<number> = new Subject<number>();
  totalSelecionados$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private carteiraFilter: CarteiraFilter;

  constructor(
    private readonly page: PageService,
    private readonly carteiraService: CarteiraService,
    private readonly messageService: ToastService,
    private readonly dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.page.defineTitle("CARTEIRA");
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onDataFetched(data: PaginationResponse) {
    this.listaCmp.updateDatasource(data);
  }

  searchEvent(pageNumber: number) {
    this.page$.next(pageNumber);
  }

  carteiraSelected($event) {
    this.totalSelecionados$.next($event);
  }

  updatePageSize($event) {
    this.pesquisaCmp.updatePageSize($event);
    this.page$.next(1);
  }

  confirmarGravarTodas() {
    this.listaCmp.selectedCarteiras = [];
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        title: 'Tem certeza?',
        message: 'Deseja gravar todas as '+ this.listaCmp.totalElements +' carteiras filtradas?',
        confirmText: 'Gravar',
        cancelText: 'Cancelar'
      },
      width: "500px",
      maxHeight: "50vh",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(confirm => {
      dialogRef.close();
      if (confirm) {
        this.gravarTodas();
      }
    })
  }

  gravarTodas() {
    this.carteiraService.updateAll(this.carteiraFilter, this.ativaEnquadramento, this.processamentoAuto).subscribe(
      _ => {
        this.messageService.textoLight("Carteira(s) atualizada(s).");
        this.pesquisaCmp.pesquisar();
      },
      err => this.messageService.erro(err.error.message)
    );
  }

  onFilterChanged($event: PageableCarteiraFilter) {
    this.carteiraFilter = new CarteiraFilter($event.nome, $event.nomeCompleto, $event.ativa, $event.auto);
  }

  gravar() {
    const carteiras = this.listaCmp.selectedCarteiras;
    carteiras.forEach((carteira) => {
      carteira.ativa = this.ativaEnquadramento;
      carteira.auto = this.processamentoAuto;
    });

    this.carteiraService.updateOrCreate(carteiras).subscribe(
      _ => {
        this.messageService.textoLight("Carteira(s) atualizada(s).");
        this.pesquisaCmp.pesquisar();
      },
      err => this.messageService.erro(err.error.message)
    );
  }
}
